<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 15h-1.11l-.7-6.33a3 3 0 00-3-2.67H12.5V5H15a.5.5 0 00.5-.5v-2A.5.5 0 0015 2H9a.5.5 0 00-.5.5v2A.5.5 0 009 5h2.5v1H7.79a3 3 0 00-3 2.67L4.11 15H3a1 1 0 00-1 1v5a1 1 0 001 1h18a1 1 0 001-1v-5a1 1 0 00-1-1zM6.8 8.89a1 1 0 011-.89h8.42a1 1 0 011 .89l.66 6.11H6.12zM20 20H4v-3h16z"/><path d="M10.5 19h3a.5.5 0 000-1h-3a.5.5 0 000 1zM8 10h8v2H8z"/></svg>